module.exports = __webpack_public_path__ + "img/DJI_0027.6c0ecb50.jpg";